import { render, staticRenderFns } from "./NXTCustomRoleUserSelector.vue?vue&type=template&id=7dbb5906&scoped=true"
import script from "./NXTCustomRoleUserSelector.vue?vue&type=script&lang=js"
export * from "./NXTCustomRoleUserSelector.vue?vue&type=script&lang=js"
import style0 from "./NXTCustomRoleUserSelector.vue?vue&type=style&index=0&id=7dbb5906&prod&scoped=true&lang=css"
import style1 from "./NXTCustomRoleUserSelector.vue?vue&type=style&index=1&id=7dbb5906&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbb5906",
  null
  
)

export default component.exports